import UAParser from "ua-parser-js";
import { v4 as uuidv4 } from "uuid";

function getHost() {
    const url = new URL(window.location.href);
    return url.host;
}

function getProtocol() {
    const url = new URL(window.location.href);
    return url.protocol;
}

function getOs() {
    const parser = new UAParser();
    const result = parser.getResult();
    return result.browser.name;
}

function getVersion() {
    const parser = new UAParser();
    const result = parser.getResult();
    return result.browser.version;
}

/**
 * return unique id for a device
 * @returns
 */
function getDeviceId() {
    return uuidv4();
}

export { getHost, getProtocol, getOs, getVersion, getDeviceId };
